import { Component, ViewChild, ElementRef } from '@angular/core';
import { Constants } from 'src/app/constants';
import { SweetServices } from 'src/services/sweet.services';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { LoginService } from '../../../../services/login/login.service';
import Swal from 'sweetalert2';
import { SessionSotrageService } from 'src/services/session-sotrage.service';
import { EnumGlobals } from 'src/app/common/enum/TipoPersona.enum';
import { passwordPolicy } from 'src/app/common/vPassword/passwordPolicy';


interface PerfilUsuario {
  nombre: string;
  fechaNacimiento: string;
  correo: string;
  rol: string;
  login: string;
  imagenPerfilUrl: string;
  imagenPerfilBase64:string;
}

@Component({
  selector: 'app-mi-perfil', 
  templateUrl: './mi-perfil.component.html',  
  styleUrls: ['./mi-perfil.component.css']  
})


export class MiPerfilComponent {

    mensajevPassword: string = '';
    pwdValid:boolean = true;

    public LimiteRequest:number;
    miPerfil =  Constants.MI_PERFIL;
    cambiandoPassword = false;
    showSavePhotoButton = false;
    selectedFile: File | null = null;

    perfil : PerfilUsuario = {
        nombre: '',
        correo: '',
        fechaNacimiento:'',
        login : '',
        imagenPerfilUrl:'',
        rol:'',
        imagenPerfilBase64:''
    };

    passwordData = {
        UsuarioId: 0,
        Password: '',
        ConfirmPassword: '', 
        Bloqueo : false,
        RolId: -1,
        OldPassword:'',
        EsPopup:true
    };

    constructor(
        private alerta: SweetServices,
        private loginService: LoginService,
        private ssstorage: SessionSotrageService,
        private catalogoService: CatalogosService, 
        private passwordPlicy:passwordPolicy){
    }
    
    ngOnInit() {
        this.cargarPerfil();
        this.LimiteRequest = EnumGlobals.LimitRequest;  
    }

    cargarPerfil() {
        let login = this.ssstorage.getCurrentSession().login

        this.loginService.obtenerInfoUsuario({ Login: login })
            .subscribe(response => {
                if (response && response.isCorrect === 'true') {
                const info = response.data.info.result;

                this.perfil = {
                    nombre: info.nombre,
                    fechaNacimiento: info.fechaNacimiento,
                    correo: info.correo,
                    rol: info.rol,
                    login: info.login,
                    imagenPerfilUrl: info.imagenPerfilUrl,
                    imagenPerfilBase64:info.imagenPerfilBase64
                };
            } else {
                this.alerta.AlertaError(response.message || 'Error al cargar perfil');
            }
        }, err => {
            this.alerta.AlertaCatch(err);
        });
    }

    guardarImagen(){
        this.loginService.subirFotoPerfil(this.ssstorage.getCurrentSession().usuarioId, this.selectedFile).subscribe(
        (res) => {
            if (res.isCorrect) {
                this.cargarPerfil();
                this.AlertaSuccessTimer("Cambio exitoso");
            } else {
                console.error(res.message);
            }
        },
        (err) => console.error('Error al subir imagen:', err)
        );

        this.showSavePhotoButton = false;
        this.selectedFile = null;
    }

   cambiarImagen(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            this.selectedFile  = input.files[0];

            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.perfil.imagenPerfilBase64 = e.target.result;
            };
            reader.readAsDataURL(this.selectedFile);
            this.showSavePhotoButton = true;
        }
    }

    ocultarFormularioPassword() {
        this.cambiandoPassword = false;
        this.passwordData.Password= '';
        this.passwordData.ConfirmPassword= '';
        this.passwordData.OldPassword = ''
    }

    guardarPassword() {
        if(!this.passwordData.Password || this.passwordData.Password.trim() === '' 
        || !this.passwordData.ConfirmPassword || this.passwordData.ConfirmPassword.trim() === '' 
        || !this.passwordData.OldPassword || this.passwordData.OldPassword.trim()=== ''){
             this.AlertaError(`Los campos de contraseña no pueden estar vacíos`);
            return ;
        }
        if(this.passwordData.Password !== this.passwordData.ConfirmPassword){
            this.AlertaError(`Nueva contraseña y Confirmar contraseña no coinciden`);
            return ;
        }

        this.passwordData.UsuarioId = this.ssstorage.getCurrentSession().usuarioId;

        this.loginService.modificarPassword(this.passwordData).subscribe(response => {
            if (response === null) {
                this.AlertaError(
                    'Existe un error, si persiste contacte al administrador del Sitio.'
                );
            } else if (response.isCorrect === 'false') {
                this.AlertaError('No fue posible cambiar la contraseña, reintente con nuevos datos.');
            } else {
                this.AlertaSuccessTimer("Cambio de contraseña exitoso");
                this.catalogoService.limpiarCatalogos(true);
                setTimeout(() => {
                    
                }, 2000);
            }
        }, (err) => {
            if(err.status == 401){
                if(this.LimiteRequest > 0){
                    this.LimiteRequest = this.LimiteRequest - 1;
                    this.guardarPassword();
                }else {
                    this.AlertaCatch(err);
                }
            }else{
                this.AlertaError(JSON.stringify(err));
            }
        });

        this.ocultarFormularioPassword();
    }

    public AlertaError(msg: string) {
        Swal.fire({
            type: 'error',
            title: 'Error',
            text: msg
        });
    }

    public AlertaSuccessTimer(msg: string) {
        Swal.fire({
            type: 'success',
            title: msg,
            showConfirmButton: false,
            timer: 3000
        });
    }

    public AlertaCatch(error: any){
        console.log(error);
        let msg = '';
        if(error.statusText == 'Unknown Error'){
          msg = 'Existe un error al intentar acceder al recurso.';
        }
        else if( error.statusText == 'Bad Request' || error.status == 400) {
          msg = 'Existe un error de formato en la petición.'
        } else if(error.status == 401){
          msg = 'Solicitud no autorizada.'
        }
    
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: msg
        });
    }

    public validatePassword(pass:string, confirmPass:string){
        var response = this.passwordPlicy.vPassword(pass, confirmPass);
        this.pwdValid = response.isValid;
        this.mensajevPassword = response.message;
    }
}